import { useDispatch, useSelector } from "react-redux";
import { editChanceSSR, editChanceSR, toggleIsPityEnabled, reset } from "features/pullsSlice";
// Chakra Imports
import {
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Input,
  InputGroup,
  InputLeftAddon,
  Menu,
  MenuButton,
  MenuList,
  Stack,
  Switch,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom Components
import { SidebarResponsive } from "components/sidebar/Sidebar";
import PropTypes from "prop-types";
import React from "react";
// Assets
import { MdNotificationsNone, MdInfoOutline, MdSettings } from "react-icons/md";

import routes from "routes.js";
import { ThemeEditor } from "./ThemeEditor";

export default function HeaderLinks(props) {
  const { secondary } = props;
  const dispatch = useDispatch();
  const isPityEnabled = useSelector(state => state.pulls.isPityEnabled);
  // Chakra Color Mode
  const navbarIcon = useColorModeValue("gray.400", "white");
  let menuBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.700", "brand.400");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  return (
    <Flex
      w={{ sm: "100%", md: "auto" }}
      alignItems='center'
      flexDirection='row'
      bg={menuBg}
      flexWrap={secondary ? { base: "wrap", md: "nowrap" } : "unset"}
      p='10px'
      borderRadius='30px'
      boxShadow={shadow}>
      {/*<SidebarResponsive routes={routes} />*/}
      <Menu>
        <MenuButton p='0px'>
          <Icon
            mt='6px'
            as={MdNotificationsNone}
            color={navbarIcon}
            w='18px'
            h='18px'
            me='10px'
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p='20px'
          borderRadius='20px'
          bg={menuBg}
          border='none'
          mt='22px'
          me={{ base: "30px", md: "unset" }}
          minW={{ base: "unset", md: "400px", xl: "450px" }}
          maxW={{ base: "360px", md: "unset" }}>
          <Flex jusitfy='space-between' w='100%' mb='20px'>
            <Text fontSize='md' fontWeight='600' color={textColor}>
              Notifications
            </Text>
            <Text
              fontSize='sm'
              fontWeight='500'
              color={textColorBrand}
              ms='auto'
              cursor='pointer'>
              Mark all read
            </Text>
          </Flex>
          <Flex flexDirection='column'>
          </Flex>
        </MenuList>
      </Menu>

      <Menu>
        <MenuButton p='0px'>
          <Icon
            mt='6px'
            as={MdInfoOutline}
            color={navbarIcon}
            w='18px'
            h='18px'
            me='10px'
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p='20px'
          me={{ base: "30px", md: "unset" }}
          borderRadius='20px'
          bg={menuBg}
          border='none'
          mt='22px'
          minW={{ base: "unset" }}
          maxW={{ base: "360px", md: "unset" }}>
          <Flex flexDirection='column'>
            <Text fontSize='md' fontWeight='600' color={textColor}>
              Info
            </Text>
            <br/>
            <Stack spacing={2}> 
              <Text>Roll the dice.</Text>
              <Text>Did you know there's a dark theme?</Text>
            </Stack>
          </Flex>
        </MenuList>
      </Menu>
      <Menu>
        <MenuButton p='0px'>
          <Icon
            mt='6px'
            as={MdSettings}
            color={navbarIcon}
            w='18px'
            h='18px'
            me='10px'
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p='20px'
          me={{ base: "30px", md: "unset" }}
          borderRadius='20px'
          bg={menuBg}
          border='none'
          mt='22px'
          minW={{ base: "unset" }}
          maxW={{ base: "360px", md: "unset" }}>
          <Flex flexDirection='column'>
            <Text fontSize='md' fontWeight='600' color={textColor}>
              Settings
            </Text>
            <br/>
            <Stack spacing={4}>
              <InputGroup size="sm">
                <InputLeftAddon children="SSR Chance" borderRadius="10px" />
                <Input placeholder="0.3 %" borderRadius="10px" onChange={(e) => dispatch(editChanceSSR(e.target.value))} />
              </InputGroup>
              <InputGroup size="sm">
                <InputLeftAddon children="SR Chance" borderRadius="10px" />
                <Input placeholder="10 %" borderRadius="10px" onChange={(e) => dispatch(editChanceSR(e.target.value))} />
              </InputGroup>
              <Checkbox defaultChecked value={isPityEnabled} onChange={() => dispatch(toggleIsPityEnabled())}>Pity</Checkbox>
              <Button onClick={() => dispatch(reset())}>Reset</Button>
            </Stack>
          </Flex>
        </MenuList>
      </Menu>

      <ThemeEditor navbarIcon={navbarIcon} /> 

    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
